import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

import { ProductLine } from "../model/product-line";

@Pipe({
    name: 'unique',
    pure: false
})

export class ProductLinesUniquePipe implements PipeTransform {
    transform(value: Array<ProductLine>): any {
        if (value !== undefined && value !== null) {
            return _.uniqBy(value, function (elem) { return [elem.ProductLineDescription.trim(), elem.ProductLineCode.trim()].join(); });
        }
        return value;
    }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/pipes/productlines-unique.pipe.ts